import type { RouteConfig } from '../types';
import { awaRoutes } from './groups/awa';
import { clientRoutes } from './groups/clients';
import { comingSoonRoutes } from './groups/comingSoon';
import { companyRoutes } from './groups/company';
import { notFoundRoutes } from './groups/dashboard';
import { errorRoutes } from './groups/errors';
import { hierarchyRoutes } from './groups/hierarchy';
import { jobRoutes } from './groups/jobs';
import { marketRoutes } from './groups/markets';
import { profileRoutes } from './groups/profile';
import { projectRoutes } from './groups/project';
import { qcReportRoutes } from './groups/qcReports';
import { qcResponsesReportRoutes } from './groups/qcResponsesReports';
import { roleRoutes } from './groups/roles';
import { sessionRoutes } from './groups/sessions';
import { settingsRoutes } from './groups/settings';
import { stateRoutes } from './groups/states';
import { structureVersionRoutes } from './groups/structureVersions';
import { taskRoutes } from './groups/tasks';
import { userAssessmentRoutes } from './groups/userAssessment';
import { userRoutes } from './groups/users';

/**
 * Main route table: the flat list of route groups the AppRouter flattens.
 *
 * Adding a feature (entity tickets): create
 * `src/router/routes/groups/<entity>.ts` exporting a {@link RouteConfig}
 * (typically `{ path, layout: DashboardLayout, children: [...] }`), append it
 * here, add its nav entry in `@/config/navigation`, and remove the path from
 * `comingSoon.ts`. Permission rules already live in
 * `@/config/auth/routeAccess`.
 */
export const routes: RouteConfig[] = [
  notFoundRoutes,

  userRoutes,
  roleRoutes,
  sessionRoutes,
  settingsRoutes,

  clientRoutes,
  companyRoutes,
  marketRoutes,
  stateRoutes,
  structureVersionRoutes,
  hierarchyRoutes,

  projectRoutes,
  jobRoutes,

  taskRoutes,

  qcReportRoutes,
  qcResponsesReportRoutes,

  ...awaRoutes,

  userAssessmentRoutes,

  errorRoutes,
  profileRoutes,

  ...comingSoonRoutes,
];
